var _defs, _circle, _rect, _rect2, _text, _text2, _text3, _text4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSepmLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Ebene_1",
    "data-name": "Ebene 1",
    width: 80,
    height: 80,
    viewBox: "0 0 911.99 911.99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, " .cls-1 { stroke-miterlimit: 10; stroke-width: 3px; fill: url(#Unbenannter_Verlauf_174); stroke: url(#Unbenannter_Verlauf_161); } .cls-2, .cls-3, .cls-4 { fill: #fff; } .cls-3, .cls-4 { font-size: 301.34px; font-family: TrebuchetMS-Bold, Trebuchet MS; font-weight: 700; } .cls-4 { letter-spacing: -0.02em; } "), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Unbenannter_Verlauf_174",
    "data-name": "Unbenannter Verlauf 174",
    cx: 252.08,
    cy: 339.59,
    r: 192.75,
    gradientTransform: "translate(-111.68 349.72) rotate(-49.34) scale(1 0.6)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#da999b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bd1717"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Unbenannter_Verlauf_161",
    "data-name": "Unbenannter Verlauf 161",
    cx: 456,
    cy: 456,
    r: 456,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#bd1717"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#bd1717"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#bd1717"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cc8b8f"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "SEPM Logo Rund") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 456,
    cy: 456,
    r: 454.5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 449.01,
    y: 142.01,
    width: 10.43,
    height: 635.29
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 504.37,
    y: 187.19,
    width: 10.43,
    height: 635.29,
    transform: "translate(-40.48 965.85) rotate(-90)"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(254.66 387.29)"
  }, "S")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(515.1 387.29)"
  }, "E")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(238.94 717.79)"
  }, "P")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(525.42 729.08)"
  }, "M")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSepmLogo);
export default __webpack_public_path__ + "static/media/SEPM_Logo.e60dbc0926d8484c89b8a87a216badd6.svg";
export { ForwardRef as ReactComponent };